import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import './Navigation.css';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClick = (e) => {
    setIsOpen(false);
  };

  return (
    <nav className={`navigation ${isSticky ? 'sticky' : ''}`}>
      <div className="container">
        <button className="mobile-menu-btn" onClick={toggleMenu}>
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <ul className={`nav-menu ${isOpen ? 'open' : ''}`}>
          <li><a href="#accueil" onClick={handleClick}>Accueil / Home / Startseite</a></li>
          <li><a href="#vision" onClick={handleClick}>Vision</a></li>
          <li><a href="#services" onClick={handleClick}>Services / Gottesdienste</a></li>
          <li><a href="#apropos" onClick={handleClick}>À Propos / About / Über Uns</a></li>
          <li><a href="#galerie" onClick={handleClick}>Galerie / Gallery</a></li>
          <li><a href="#contact" onClick={handleClick}>Contact / Kontakt</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
